module.exports = __webpack_public_path__ + "img/pc-tab-icon5.b1def4ef.png";